
export var NetsolinApp = {
  // urlNetsolin: "http://40.85.161.231/CERCANOSREST/",
  urlNetsolin: "",
  url_netsolin_alterna: '',
  // urlNetsolinverilicen: 'http://40.85.161.231/CERCANOSREST/',
  urlNetsolinverilicen: '',
  urlwebnetsolin: '',
  iniNetsolin: false,
  oappapl: {},
  oapl_contabil: {},
  oapl_operativos: {},
  oapp: {
    "nom_empresa": '',
    "nit_empresa": '',
    "cuserid": '',
    "cuserpsw": '',
    "motor":7,
    "prefijo_sqlbd": '',
    "par_urlwebsolin": '',
    "nomusuar": '',
    "superusuar": '',
    "num_version": '1.1.3',
    "en_prod": '',
    "obj_actual": 'CODOBJ',
    "par_pucd" : false,
    "par_pucc" : false,
    "par_puscc" : false,
    "fecha_proceso": new Date(),
    "dg_aplica" : ''
  },
  objtitmodulo: {
    "titulo": "Titulo Modulo",
    "Menu": "menu"
  },
  objenvrest: {
    "usuario": "NETSOLIN",
    "psw": "psww",
    "prefijobd": "",
    "parametros":{},
    "en_prod": '',
    "prod":"",
    "tiporet":"",
    "filtro": "nombre like 'A%'",
    "tokenfb":null,
    "cod_objeto":""
  },
  objenvrestddtabla: {
    "usuario": "NETSOLIN",
    "psw": "psww",
    "prefijobd": "",
    "aplica": 0,
    "objeto": "",
    "en_prod": '',
    "exporta": "",
    "tokenfb":null,
    "tabla": ""
  },
  objpartablabas: {
    "titulo": "",
    "subtitulo": "",
    "rutamant": "",
    "prefopermant": "",
    "objeto": "",
    "aplica": 0,
    "tabla": "",
    "campollave": "",
    "camponombre": "",
    "clase_nbs": "",
    "clase_val": "",
    "campos_lista":{},
    "tokenfb":null,
    "orden": ""
  },

  objenvrestsolcomobog: {
    "usuario": "NETSOLIN",
    "psw": "psww",
    "prefijobd": "",
    "parametros":{},
    "filtro": "nombre like 'A%'",
    "tabla": "CIUDADES",
    "orden": "1",
    "campos": "*",
    "cursor": "Tdatos",
    "campollave": "",
    "llave": "",
    "filtroadi":"",
    "en_prod": '',
    "objeto":"",
    "tokenfb":null,
    "aplica": 0

  },
  objenvrestcrud: {
    "usuario": "NETSOLIN",
    "psw": "psww",
    "prefijobd": "",
    "filtro": "nombre like 'A%'",
    "tabla": "CIUDADES",
    "clase_nbs": "",
    "clase_val": "",
    "orden": "1",
    "campos": "*",
    "cursor": "Tdatos",
    "campollave": "",
    "llave": "",
    "aplica": 0,
    "objeto": "",
    "en_prod": '',
    "exporta": "",
    "delete": "N",
    "tokenfb":null,
    "datos": {}
  },
  objseguridad: {
    "objeto": "",
    "per_adicionar": false,
    "per_consultar": false,
    "per_modificar": false,
    "per_eliminar": false
  },
  param_precioven: {
    "lista": "",
    "cod_refven": "100    ",
    "cod_tercer": "",
    "proc_ven": "016 ",
    "tokenfb":null,
    "cantidad":10
  },
  copiaCrumbs: {
    "titulopag": '',
    "rutaanterior":  '',
    "titrutaanterior": '',
    "tokenfb":null,
    "mostrarbreadcrumbs":  true
  },
  traerTablaDic:{
    "usuario":"NETSOLIN",
    "psw":"psww",
    "prefijobd":"SITC",
    "aliastabla":"",
     "en_prod":"PROD",
     "tokenfb":null,
     "aplica":10
  },
  modulos:{
    "usuario":"NETSOLIN",
    "psw":"psww",
    "prefijobd":"SITC",
    "en_prod":"PROD",
    "tokenfb":null,
    "aplica":0
  }
};
